import React, { useState, useEffect } from 'react';
import moment from 'moment/moment';

//Components
import TabelaListagem from '../../../../components/TabelaListagem/TabelaListagem';

export default function TabelaAgendamentos({ items = [], actions = [] }) {
    //Estado de controle dos items da tabela
    const [agendamentos, setAgendamentos] = useState([]);

    //Carrega os items da tabela com a data formatada
    useEffect(() => {
        setAgendamentos([...items.map(value => {
            const _value = { ...value };
            _value.dataAgendamento = moment(_value.dataAgendamento).format("DD/MM/YYYY");
            return _value;
        })]);
    }, [items]);

    //Headers da tabela de listagem de agendamentos
    const headers = [
        { value: "Fiscal", objectValue: "fiscal", align: "left" },
        { value: "Data do agendamento", objectValue: "dataAgendamento", align: "left" },
        { value: "Status", objectValue: "status", align: "right" },
        { value: "Observações", objectValue: "observacoes", align: "right" },
        { value: "Enquadramento", objectValue: "resultado", align: "right" },
    ]
    return (
        <TabelaListagem title='Lista de agendamentos' headers={headers} items={agendamentos} actions={actions} />
    )
}